import image from "../assets/sign_up.jpg";
interface ImageBannerProps {
  title: string;
}

const ImageBanner: React.FC<ImageBannerProps> = ({ title }) => {
  return (
    <div
      className="relative ml-0 mr-0 w-screen mb-10 "
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay for darkening the background image */}
      <div
        className="absolute inset-0 "
        style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
      ></div>

      {/* Content Section */}
      <div className="relative p-6 w-full justify-centers items-center h-auto py-14">
        {/* Header Section */}
        <div className="w-full flex items-center justify-center">
          <h2 className="text-xl font-bold text-white">{title}</h2>
        </div>
      </div>
    </div>
  );
};

export default ImageBanner;
